import { render, staticRenderFns } from "./searchModeConfig.vue?vue&type=template&id=5b585833&scoped=true&"
import script from "./searchModeConfig.vue?vue&type=script&lang=js&"
export * from "./searchModeConfig.vue?vue&type=script&lang=js&"
import style0 from "./searchModeConfig.vue?vue&type=style&index=0&id=5b585833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b585833",
  null
  
)

export default component.exports